module.exports = __webpack_public_path__ + "static/media/ΠΡΟΤΥΠΟ ΑΦΙΣΑ_2.ef4044e6.mp4";